import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RouterUrl } from 'routes';
import { getPDL } from 'api';
import { useAppSelector } from '../store/hooks';
import { selectUser } from '../store/slices/user';
import type { IProductCalculator } from 'interfaces/activeApllication';

export const useFetchPDL = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [productRules, setProductRules] = useState<IProductCalculator | null>(null);

  const navigate = useNavigate();
  const { state } = useLocation();
  const { userInfo } = useAppSelector(selectUser);

  useEffect(() => {
    let stillMounted = true;

    const getData = async () => {
      try {
        const response = await getPDL();
        setProductRules(response);

        setIsLoading(false);
      } catch (error: any) {
        if (error?.response?.data?.detail === 'Full authentication is required to access this resource.') {
          navigate(RouterUrl.Login);
        }
        setProductRules(null);
        setIsLoading(false);
        throw error;
      }
    };

    if (stillMounted && !state?.partialView) {
      getData();
    }

    return () => {
      stillMounted = false;
    };
  }, []);

  return {
    isLoading,
    productRules,
    userInfo,
  };
};
